
import { defineComponent, ref } from "vue";
import AddTag from "@/components/AddTag.vue";
import VideoPreview from "@/components/VideoPreview.vue";
import SongEditor from "@/components/SongEditor.vue";
import Loader from "@/components/Loader.vue";
import firebase from "@/firebase/firebase";
import { v4 as uuidv4 } from "uuid";

export default defineComponent({
  name: "CreateSongsData",
  components: { AddTag, VideoPreview, SongEditor, Loader },
  setup() {
    const _sleep = (ms: number) =>
      new Promise((resolve) => setTimeout(resolve, ms));
    return {
      _sleep,
      src: ref(""),
      showComplete: ref(false),
      showLoader: ref(false),
    };
  },
  methods: {
    play(start: number) {
      console.log("createsongdata", start);
      const tmp: any = this.$refs.video;
      console.log(start);
      tmp.jumpAt(start);
      tmp.play();
    },
    changeVideo(url: string) {
      console.log("createsongsdata", url);
      this.src = url;
    },
    save: async function (songs: any) {
      console.log(songs);
      const user: any = firebase.auth().currentUser;
      let uid: string = user.uid;
      if (uid == null) uid = "unknown";
      this.showLoader = true;
      const db = firebase.firestore();
      let ok = true;
      songs.forEach((song: any) => {
        db.collection("songs")
          .doc(uuidv4())
          .set({
            screenTitle: song.screenTitle,
            start: song.start,
            end: song.end,
            videoId: song.videoId,
            tag: song.tags,
            authorId: uid,
          })
          .then(() => {
            console.log("add success");
          })
          .catch((err: Error) => {
            console.log("add failed");
            alert(err);
            ok = false;
          });
      });

      this.showLoader = false;
      if (ok) this.showComplete = true;
    },
    setTagsFilter() {
      const tmp: any = this.$refs.songEditor;
      tmp.setTagsFilter();
    },
    reload() {
      this.src = "";
      const tmp: any = this.$refs.songEditor;
      console.log(tmp);
      tmp.reload();
      this.showComplete = false;
      this.showLoader = false;
    },
  },
});
